
export default {
  props: {
    product: {
      type: Object,
    },
  },
};
